import * as React from 'react';

import '@app/scss/components/cardResource.scss';

const CardResource = (props) => {
	const {position, name, phone, url} = props;
	return (
		<div className="card-resource">
			<a href={url} target="_blank" className="card-resource__position">{position}</a>
			<p className="card-resource__name">{name}</p>
			<a className="card-resource__phone" href={`tel:${phone}`}>
				<img className="card-resource__phone-icon" src={require('@app/images/call_icon.svg')} alt="Phone Icon" />
				<img className="card-resource__phone-icon card-resource__phone-icon_hovered" src={require('@app/images/call_icon_white-filled-white.svg')} alt="Phone Icon" />
				<span>{phone}</span>
			</a>
		</div>
	);
};

export default CardResource;
